import { styled } from '@mui/system';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Chip, Button } from '@mui/material';
import { NotificationsActiveRounded } from '@mui/icons-material';

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  margin: theme.spacing(0),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(0, 1)
  },
  '&:not(:last-child)': {
    borderBottom: 0
  },
  '&:before': {
    display: 'none'
  },
  '&.Mui-expanded': {
    borderRadius: theme.spacing(1),
    boxShadow: 'none',
    margin: theme.spacing(2, 0),
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(2, 0)
    }
  }
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  flexDirection: 'row-reverse',
  padding: 0,
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  },
  '&:hover': {
    cursor: 'default !important'
  },
  '&& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  }
}));

export const StyledAccordionDetails = styled(AccordionDetails, {
  shouldForwardProp: prop => prop !== 'isEmpty'
})(({ theme, isEmpty }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gridAutoColumns: 'minmax(auto, 33%)',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  [theme.breakpoints.up('FWXGA')]: {
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gridAutoColumns: 'minmax(auto, 24%)'
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    gridAutoColumns: 'minmax(auto, 100%)'
  },
  ...(isEmpty && {
    position: 'relative',
    margin: theme.spacing(1.5, 0),
    display: 'flex',
    justifyContent: 'center'
  })
}));

export const ProjectLabel = styled('span')(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey[500]
}));

export const WarehouseLabel = styled(Typography)({
  maxWidth: 600
});

export const TooltipWrapper = styled('div')({
  position: 'absolute',
  right: 10
});

export const AddAppCardButton = styled(Button)({
  color: 'white',
  borderRadius: 7,
  marginRight: '50px',
  width: 190
});

export const StyledChip = styled(Chip)({
  overflow: 'hidden',
  borderRadius: '7px',
  width: '100%',
  height: 60,
  '& > span': {
    width: '100%'
  }
});

export const ChipLabelContainer = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& span:first-of-type': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 170
  },
  '& span:last-of-type': {
    color: theme.palette.grey[700],
    width: 140,
    textAlign: 'right',
    '& span': {
      verticalAlign: 'middle',
      lineHeight: '36px'
    }
  },
  '& svg': {
    marginRight: 4,
    verticalAlign: 'middle'
  }
}));

export const BellIcon = styled(NotificationsActiveRounded)(({ theme }) => ({
  color: theme.palette.grey[600],
  marginLeft: 4
}));

export const ButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 60
});

export const SiteCardButtonContainer = styled('div')({
  display: 'flex',
  alignItems: 'center'
});

export const LabelContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column'
});
